<app-loader></app-loader>
@if (clntDtls && clntDtls.length && !full_screen) {
<app-header></app-header>
} @if (clntDtls && clntDtls.length && !full_screen) {
<app-sidenav></app-sidenav>
}
<router-outlet></router-outlet>
